module.exports = __webpack_public_path__ + "static/cert-2b75c27ab4b2a144037c671dd05a1852.jpg";